import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../../../../locales/translations';

export const useTexts = () => {
  const { t } = useTranslation(
    TranslationsKeys.TEACHER_MANAGMENT_TEACHER_FILE_ASSIGNED_STUDENTS,
  );

  const texts = useMemo(
    () => ({
      modal: {
        title: t(`modal.title`),
        subtitle: t(`modal.subtitle`),
        form: {
          ...t<string, any>(`form`, {
            returnObjects: true,
          }),
        },
        actions: {
          ...t<string, any>(`actions`, {
            returnObjects: true,
          }),
        },
        saveSuccess: t(`modal.message.saveSuccess`),
        saveError: t(`modal.message.saveError`),
      },
      confirmModal: {
        title: t(`confirmModal.title`),
        description: t(`confirmModal.description`),
        actions: {
          ...t<string, any>(`actions`, {
            returnObjects: true,
          }),
        },
        saveSuccess: t(`confirmModal.message.saveSuccess`),
        saveError: t(`confirmModal.message.saveError`),
      },
    }),
    [t],
  );

  return texts;
};
